export default "__VITE_ASSET__ace5029a__"